import React from 'react'

import Supernova from './images/IMG_0003.jpg'
import OrangeMosaic from './images/DSC_1655.jpg'
import I80 from './images/DSC_1605.jpg'
// import YellowMosaic from './images/IMG_0006.jpg'
import HeavenByNight from './images/DSC_1698.jpg'
import HeavenByDay from './images/IMG_0251.jpg'
import Firefly from './images/IMG_0247.jpg'
import FirstWoman from './images/DSC_1631.jpg'
import MadonnaWithChild from './images/DSC_1610.jpg'
import TheStrength from './images/DSC_1643.jpg'
import TheRenaissance from './images/DSC_1616.jpg'
import SelfLove from './images/DSC_1642.jpg'
import TheGoddess from './images/IMG_0244.jpg'
// import PointyBirds from './images/IMG_0034.jpg'
// import PurpleTextile from './images/IMG_0022.jpg'
import GreenTextile from './images/IMG_0021.jpg'
import RedMosaic from './images/IMG_0007.jpg'
import SundayWindows from './images/IMG_0005.png'
import Nebula from './images/DSC_1714.jpg'
import TheDeparted from './images/DSC_1710.jpg'
import WoodTrypticMosaic from './images/DSC_1686.jpg'
import GreenMosaic from './images/DSC_1667.jpg'
import Stripes from './images/DSC_1578.jpg'
import ThreeByThree from './images/3x3.png'
import GreenPeacock from './images/IMG_0020.png'

import ArtCard from './ArtCard';

const imageData = [
  [Supernova, 'Supernova','30"x24"','Glitter, Glue & Marker'],
  [OrangeMosaic, 'Orange Mosaic','20"x16"','Acrylic, Glue, Glitter & Marker'],
  [I80, 'I-80','17"x35"','Acrylic, Glue, Glitter & Marker'],
  [HeavenByDay, 'Heaven By Day','48"x 36"','Silver Leaf, Acrylic, Glue, Glitter & Marker'],
  [HeavenByNight, 'Heaven By Night','48"x 36"','Embossing Paint, Acrylic, Glue, Glitter'],
  [Firefly, 'Firefly','48"x30"','Glitter, Glue & Marker'],
  [FirstWoman, 'First Woman','20"x12"','Acrylic, Glue, Gold Leaf, Sand'],
  [MadonnaWithChild, 'Madonna With Child','20"x12"','Acrylic, Glue, Glitter'],
  [TheStrength, 'The Strength','20"x12"','Acrylic'],
  [TheRenaissance, 'The Renaissance','20"x12"','Acrylic, Glitter, Glue, Silver Leaf'],
  [SelfLove, 'Self Love','20"x12"','Copper Leaf, Glitter, Glue, Acrylic'],
  [TheGoddess, 'The Goddess','20"x12"','Acrylic, Glitter, Glue, Sand'],
  [GreenTextile, 'Green Textile','18"x14"','Acrylic, Glitter, Glue'],
  [RedMosaic, 'Red Mosaic','20"x16"','Acrylic, Glitter, Glue, Marker'],
  [SundayWindows, 'Sunday Windows','36"x12"','Acrylic, Glitter, Glue, Marker'],
  [Nebula, 'Nebula','48"x 18"','Acrylic, Glitter, Glue, Marker, Sand, Salt'],
  [TheDeparted, 'The Departed','47"x 17"','Acrylic, Glitter, Glue'],
  [WoodTrypticMosaic, 'Wood Tryptic Mosaic','12"x 36"','Glitter, Glue, Marker'],
  [GreenMosaic, 'Green Mosaic','20"x 16"','Acrylic, Glitter, Glue, Marker'],
  [Stripes, 'Stripes','22"x 22"','Duct tape, Glitter, Glue'],
  [ThreeByThree, 'Three By Three','12"x 12"','Acrylic, Glitter, Glue, Marker'],
  [GreenPeacock, 'Green Peacock','40"x 28"','Acrylic'],
].map(c => ({src:c[0], title:c[1], dimensions:c[2], medium:c[3], sold:c[4]}))

  // Removed items
  // [YellowMosaic, 'Yellow Mosaic', true],
  // [PointyBirds, 'Pointy Birds'],
  // [PurpleTextile, 'Purple Textile'],


const artCards = imageData.map((props,i) =>
  (<ArtCard {...props} key={i}/>));

export default artCards;
export const ImageData = imageData;



// WEBPACK FOOTER //
// ./src/Art.js